import axios from 'axios';
import { getCookie, deleteCookie } from '../../utils/common';
import { env } from '../../utils/env';

const API_BASE_URL = env('REACT_APP_API_BASE_URL') || 'http://localhost:8000/api';
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Accept': 'application/json',
  },
});

console.log(API_BASE_URL);
axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const noAuthRequired = [
        '/login/new-account',
        '/login/check-password',
        '/login/set-password',
      ];

      const skipAuth = noAuthRequired.some((endpoint) =>
        config.url?.includes(endpoint)
      );

      if (!skipAuth) {
        const accessToken = getCookie('accessToken');
        if (accessToken) {
          const authHeader = `Bearer ${accessToken}`; 
          config.headers['Authorization'] = authHeader;
          
          //console.log('Adding Authorization header:', authHeader); 
          
        }
      }

      return config;
    } catch (error) {
      console.error("Error in request interceptor:", error);
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; 
      console.log("401 error detected, attempting token refresh/logout");

      
      const refreshToken = getCookie('refreshToken'); 
      if (!refreshToken) {
        console.log("No refresh token found, logging out.");
        
        window.dispatchEvent(new Event('forceLogout'));
        return Promise.reject(error);  
      } else {
        
      }
    }

    console.error("API Error:", error);
    return Promise.reject(error);
  }
);



export default axiosInstance;